import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'

import { Form } from 'components/layout'
import { ActivityLog } from 'components/sections/activities'
import { form } from 'helpers/decorators'
import validate from 'models/activities/validateLogs'

const enhance = compose(
  form({
    form: 'addLogForm',
    validate
  })
)

class LogAdd extends Component {
  static propTypes = {
    activityId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    createActivityLog: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  render() {
    const {
      handleSubmit,
      createActivityLog,
      activityId,
      onClose,
      submitting
    } = this.props

    return (
      <Form
        onSubmit={handleSubmit(fields => createActivityLog(activityId, fields))}
      >
        <ActivityLog
          onClose={onClose}
          title="Add log"
          intlKey="logs.add_log"
          isLoading={submitting}
        />
      </Form>
    )
  }
}

export default enhance(LogAdd)
